import styled from 'styled-components';

export const Input = styled.input`
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 400;
  height: calc(1.5em + 0.75rem + 2px);
  line-height: 1.5;
  max-width: 100%;
  padding: 0.375rem 0.75rem;
  width: -webkit-fill-available;

  &:focus-visible {
    outline: none;
  }
`;
